import { MOBILE_WIDTH } from "screens/campaignManagement/adReview/adCardListContainer/facebookAdCard/constants";
import { IDimension } from "shared/types/designStudio";

export const DEFAULT_DIMENSION: IDimension = {
  width: MOBILE_WIDTH,
  height: 565,
};

export const GAP = 100;
